import { Directive, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { Asset, OrderDirection, Quote } from '@zero/shared/util-models';
import { TradeService } from '@zero/trade/domain';

@Directive()
export class TradeCreateQuoteComponentBase implements OnChanges {
  @Input() public asset?: Asset;
  @Input() public quote?: Quote;
  @Input() public direction?: OrderDirection = 'buy';

  public readonly tradeService = inject(TradeService);

  public quoteFormat = '1.2-2';
  public isBuy = false;

  public ngOnChanges(changes: SimpleChanges): void {
    this.isBuy = this.direction === 'buy';
    if (!changes['asset']?.currentValue) {
      return;
    }

    const { priceScale } = this.asset;
    if (priceScale) {
      this.quoteFormat = `1.${priceScale}-${priceScale}`;
    }
  }
}
